import {
  FlexBox,
  Lightbox,
  Modal,
  ModalBody,
  ModalHead,
  Spinner,
  SrcType,
} from '@dixa/lib-shared-habla';
import { Component, lazy, Suspense } from 'react';

import {
  isExcelAttachment,
  isImageAttachment,
  isPdfAttachment,
  isVideoAttachment,
} from '../../../../app/utils/attachments';

import VideoLightbox from './VideoLightbox';

const XlsxLightbox = lazy(
  () => import(/* webpackChunkName: "xlsxLightbox" */ './XlsxLightbox'),
);

const PDFLightbox = lazy(
  () => import(/* webpackChunkName: "pdflightbox" */ './PDFLightbox'),
);

type PropsT = {
  fileName: string;
  url: SrcType | string;
  closeModal: () => void;
};

export default class AttachmentsPreviewModal extends Component<PropsT> {
  render() {
    const { fileName, url, closeModal } = this.props;

    if (isImageAttachment(fileName)) {
      return (
        <Lightbox
          isOpen={!!url}
          src={url as SrcType}
          onClose={closeModal}
          className="modal-z-middle"
        />
      );
    }

    if (isExcelAttachment(fileName)) {
      return (
        <Suspense
          fallback={
            <Modal isOpen allowClickOutside onClose={closeModal}>
              <ModalHead title="" onClose={closeModal} />
              <ModalBody>
                <FlexBox width="540px" justifyContent="center">
                  <Spinner size={32} />
                </FlexBox>
              </ModalBody>
            </Modal>
          }
        >
          <XlsxLightbox
            fileName={fileName as string}
            url={url as string}
            onClose={closeModal}
            className="modal-z-middle"
          />
        </Suspense>
      );
    }
    if (isPdfAttachment(fileName)) {
      return (
        <Suspense
          fallback={
            <Modal isOpen allowClickOutside onClose={closeModal}>
              <ModalHead title="" onClose={closeModal} />
              <ModalBody>
                <FlexBox width="540px" justifyContent="center">
                  <Spinner size={32} />
                </FlexBox>
              </ModalBody>
            </Modal>
          }
        >
          <PDFLightbox
            src={url as string}
            onClose={closeModal}
            className="modal-z-middle"
          />
        </Suspense>
      );
    }
    if (isVideoAttachment(fileName)) {
      return (
        <Suspense
          fallback={
            <Modal isOpen allowClickOutside onClose={closeModal}>
              <ModalHead title="" onClose={closeModal} />
              <ModalBody>
                <FlexBox width="540px" justifyContent="center">
                  <Spinner size={32} />
                </FlexBox>
              </ModalBody>
            </Modal>
          }
        >
          <VideoLightbox
            fileName={fileName as string}
            url={url as string}
            onClose={closeModal}
            className="modal-z-middle"
          />
        </Suspense>
      );
    }
    return null;
  }
}
